export const GET_PRODUCTS_BY_USERNAME_SUCCESS = 'GET_PRODUCTS_BY_USERNAME_SUCCESS';
